import { defineComponent, h, withDirectives, resolveDirective } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import token from '@/Services/token';
import { QInput } from 'quasar';

import { appSettings } from '@/Shared/appSettings.js';

//const libphonenumber = require('google-libphonenumber');
import libphonenumber from 'google-libphonenumber';

import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-phonenumber',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QInput,
    },
    data: () => ({
        customerRegionCode: null,
    }),
    props: {
    },
    created() {
        this.phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        this.customerRegionCode = token.CustomerRegionCode();
        if (!this.customerRegionCode)
            this.customerRegionCode = 'US';
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        formattedvalue: function () {
            return this.f_phoneNumber(this.itemvalue);
        },
    },
    methods: {
        syncformatted(value) {
            if (value) {
                try {
                    const parsedPhoneNumber = this.phoneUtil.parse(value, this.customerRegionCode);
                    this.sync(this.phoneUtil.format(parsedPhoneNumber, libphonenumber.PhoneNumberFormat.E164));
                }
                catch (e) {
                    utils.warn(`Warning! phone number failed to parse: ${value}`, e);
                    this.sync(value);
                }
            }
        },
    },
    render() {
        let slots = {
            message: ({message}) => {
                return <TranslationContainer context={this} value={message}></TranslationContainer>
            }
        }
        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;

        let input = (
            <QInput
                class="caption sform-input-white"
                outlined
                dense
                labelSlot={this.hasInputLabel}
                style={{ width: "100%" }}
                modelValue={this.formattedvalue}
                rules={this.rules} {...this.compilerErrorFieldProps}
                onUpdate:modelValue={(value) => this.temp_value = value}
                onFocus={() => {
                    this.temp_value = this.itemvalue;
                    this.onFocus();
                }}
                onBlur={() => {
                    this.syncformatted(this.temp_value);
                    this.onBlur();
                }}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
                hint={this.inputHint}
                hide-hint
                bottom-slots={this.showFieldBottomSlots}
            >{slots}</QInput>
        );

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);
        //input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return input;

        //return (
        //    <tr class="pa-0 ma-0">
        //        <td style={{ width: "1px" }}>
        //            <span style={{ whiteSpace: "nowrap" }}>{title} {desc}</span>
        //        </td>
        //        <td class="pa-0 ma-0" class={{ "property-grid": this.condensed }}>
        //            {input}
        //        </td>
        //    </tr>
        //);
    }
});